module.exports = __webpack_public_path__ + "img/5home.0bb902d0.png";